import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import { getUuid } from 'store/auth/selectors';
import { markAllReadAction } from 'store/pushNotifications/actions';
import { selectPushNotificationUnreadCount } from 'store/pushNotifications/selectors';

import PushNotificationFeed from './components/PushNotificationFeed';
import PushNotificationFilterBar from './components/PushNotificationFilterBar';
import {
  headerStyles,
  headerTitleWrapperStyles,
  panelContentStyles,
  wrapperStyles,
} from './PushNotificationPanel.styles';
import { PushNotificationPanelTestIds } from './PushNotificationPanel.testIds';

const PushNotificationPanel = ({ onClose, withBackButton = false }) => {
  const dispatch = useDispatch();
  const scrollContainerRef = useRef();

  const unreadCount = useSelector(selectPushNotificationUnreadCount);
  const userId = useSelector(getUuid);

  const onMarkAllRead = useCallback(() => {
    if (!userId) {
      return;
    }

    dispatch(markAllReadAction({ userId }));
  }, [dispatch, userId]);

  return (
    <Box sx={wrapperStyles}>
      <Box sx={headerStyles}>
        <Box sx={headerTitleWrapperStyles}>
          {withBackButton && (
            <IconButton data-testid={PushNotificationPanelTestIds.BACK_BUTTON} onClick={onClose}>
              <ArrowCheckIcon direction={IconDirection.LEFT} size={IconSize[16]} />
            </IconButton>
          )}

          <Typography variant="medium20">Notifications</Typography>
        </Box>

        {!!unreadCount && (
          <Button
            data-testid={PushNotificationPanelTestIds.MARK_ALL_READ_BUTTON}
            size="small"
            variant="text"
            onClick={onMarkAllRead}
          >
            Mark all as read
          </Button>
        )}
      </Box>

      <Divider />

      <PushNotificationFilterBar />

      <Box ref={scrollContainerRef} sx={panelContentStyles}>
        <PushNotificationFeed scrollContainerRef={scrollContainerRef} onClose={onClose} />
      </Box>
    </Box>
  );
};

PushNotificationPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  withBackButton: PropTypes.bool,
};

export default PushNotificationPanel;
